import kamala from '../../kamala'
import DataGrid from './DataGrid'
import DataGridColumn from './DataGridColumn'
import { SelectionMode } from './config'

const KDataGridFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(DataGrid.name, DataGrid)
    Vue.component(DataGridColumn.name, DataGridColumn)
  },
  SelectionMode,
  KDataGrid: DataGrid,
  KDataGridColumn: DataGridColumn,
}

export { SelectionMode, DataGrid, DataGridColumn }

export default KDataGridFamily
